import { useEffect, useState } from "react";
import { FaCheck, FaPencilAlt } from "react-icons/fa";
import { GrFormClose } from "react-icons/gr";
import { toast } from "react-toastify";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { AiFillMessage } from 'react-icons/ai';
import ModalIsFinanciableComponent from "../ModalIsFinanciableComponent";
import useModal from "../../../Hooks/useModal";
import { PutAnalysisJustification } from "../../../API/AnalysisAPI";

interface IIsFinanciableComponent {
    justificationDefault: string,
    analysisId: string,
    toggleLoading: (data: boolean) => void,
    setValueHasChanged: React.Dispatch<React.SetStateAction<boolean>>,
    pl: number,
    hasAlert: boolean,
    canNotEdit: boolean,
    userEmail: string,
    companyId: string,
    potentialValue: number,
    financialValue: number,
    hasConcluded: boolean
}

const IsFinanciableComponent = (props: IIsFinanciableComponent) => {
    const { showModal, toggleShowModal } = useModal();
    const [justification, setJustification] = useState<string>(props.justificationDefault);
    const [sendInfos, setSendInfos] = useState<boolean>(false);

    const submitObservation = async () => {
        try {
            props.toggleLoading(true);

            await PutAnalysisJustification(props.analysisId, justification, props.userEmail, props.companyId).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setSendInfos(false);
                    props.setValueHasChanged(true);
                }
            }).finally(() => props.toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            props.toggleLoading(false);
        }
    }

    useEffect(() => {
        if (sendInfos) {
            submitObservation();
        }
    }, [sendInfos]);

    useEffect(() => {
        setJustification(props.justificationDefault);
    }, [props.justificationDefault]);

    return (
        <div className='mb-2 mt-4'>
            <ModalIsFinanciableComponent
                show={showModal}
                toggleShow={toggleShowModal}
                observation={justification}
                setObservation={setJustification}
                setSendInfos={setSendInfos}
                analysisId={props.analysisId}
                companyId={props.companyId}
                setValueHasChanged={props.setValueHasChanged}
                toggleLoading={props.toggleLoading}
                userEmail={props.userEmail}
                financialValue={props.financialValue}
                potentialValue={props.potentialValue}
                hasConcluded={props.hasConcluded}
            />
            <div className='container-financial-potency'>
                <div className='form-control h-100 container-text-financial w-50 border-0 rounded-0 d-flex align-items-center'>
                    <span className='font-weight-bold'>Análise de Crédito é favorável?</span>
                </div>
                <div className='form-control d-flex align-items-center h-100 border-0 rounded-0 back-light container-relative'>
                    <span className='text-modality'>
                        {props.hasAlert && (!props.justificationDefault || props.justificationDefault == "") ?
                            <GrFormClose size={20} className='color-wrong' />
                            :
                            <FaCheck size={15} className='color-check' />
                        }
                        <span className='fw-bold ms-1'>
                            {props.hasAlert && (!props.justificationDefault || props.justificationDefault == "") ? "Aaah.. não será possível no momento... 😥" : props.hasAlert && props.justificationDefault != "" ? "Sim, mas com observação... 🤭" : "Uhuu! a análise de crédito é favorável! 🎉🎉"}
                        </span>
                    </span>

                    {(props.hasAlert && !props.hasConcluded && !props.canNotEdit && props.pl > 0 && (!props.justificationDefault || props.justificationDefault == "")) &&
                        <button onClick={() => toggleShowModal()} className='btn button-update button-right'>
                            <FaPencilAlt size={15} />
                        </button>
                    }

                    {(props.hasAlert && props.justificationDefault && !props.canNotEdit && props.justificationDefault != "") &&
                        <button onClick={() => toggleShowModal()} className='btn button-update button-right'>
                            <AiFillMessage size={15} />
                        </button>
                    }
                </div>
            </div>
        </div>
    )
}

export default IsFinanciableComponent